import { useState, useEffect } from "react";
import {
  Card,
  TextInput,
  Button,
  Stack,
  Title,
  Text,
  Divider,
  Grid,
  Badge,
  Group,
  Loader
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { differenceInDays } from "date-fns";
import { useParams } from "react-router-dom";
import axios from "axios";
import useFetch from "../../clients/features/get_withcredentials";
import getCsrfToken from "../../clients/features/get_csrfToken";

export default function ManualReservation() {

  const { hotelId } = useParams();

  const { data: rooms = [] } = useFetch(
    `https://api.komorotel.com/api/hotels/rooms/${hotelId}`
  );

  const [selectedRoom, setSelectedRoom] = useState(null);
  const [dates, setDates] = useState([null, null]);
  const [total, setTotal] = useState(null);
  const [loadingPrice, setLoadingPrice] = useState(false);

  const [guest, setGuest] = useState({
    firstname: "",
    lastname: "",
    phone: ""
  });

  const nights =
    dates[0] && dates[1]
      ? differenceInDays(new Date(dates[1]), new Date(dates[0])) || 1
      : 0;

  useEffect(() => {

    const fetchPrice = async () => {

      if (!selectedRoom || !dates[0] || !dates[1]) return;

      try {

        setLoadingPrice(true);

        const res = await axios.get(
          "https://api.komorotel.com/api/tarifs/calculate-room-price",
          {
            params: {
              roomId: selectedRoom._id,
              startDate: dates[0],
              endDate: dates[1]
            }
          }
        );

        setTotal(res.data.total);

      } catch (err) {

        console.error("Erreur calcul prix", err);

      } finally {

        setLoadingPrice(false);

      }

    };

    fetchPrice();

  }, [selectedRoom, dates]);

  const handleSubmit = async () => {


    await axios({
      method: "post",
      url: "https://api.komorotel.com/api/reservation",
      withCredentials: true,

      data: {
        source: "admin",
        guest: {
          firstName: guest.firstname,
          lastName: guest.lastname,
          phone: guest.phone
        },
        checkInDate: dates[0],
        checkOutDate: dates[1],
        roomId: selectedRoom._id,
        hotelId,
        totalPrice: total
      }
    });

    alert("Réservation créée !");
  };

  return (

    <Card
      shadow="lg"
      radius="lg"
      p="xl"
      style={{ maxWidth: 850, margin: "30px auto" }}
    >

      <Stack gap="md">

        <Title order={3}>Nouvelle réservation</Title>

        <Divider />

        <Grid>

          <Grid.Col span={4}>
            <TextInput
              label="Prénom"
              value={guest.firstname}
              onChange={(e) =>
                setGuest({ ...guest, firstname: e.target.value })
              }
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <TextInput
              label="Nom"
              value={guest.lastname}
              onChange={(e) =>
                setGuest({ ...guest, lastname: e.target.value })
              }
            />
          </Grid.Col>

          <Grid.Col span={4}>
            <TextInput
              label="Téléphone"
              value={guest.phone}
              onChange={(e) =>
                setGuest({ ...guest, phone: e.target.value })
              }
            />
          </Grid.Col>

          <Grid.Col span={12}>

            <Text fw={600} mb={6}>
              Choisir une chambre
            </Text>

            <Grid>

              {rooms.map((room) => (

                <Grid.Col span={6} key={room._id}>

                  <Card
                    withBorder
                    p="sm"
                    radius="md"
                    style={{
                      cursor: "pointer",
                      border:
                        selectedRoom?._id === room._id
                          ? "2px solid #228be6"
                          : "1px solid #eee"
                    }}
                    onClick={() => setSelectedRoom(room)}
                  >

                    <Group justify="space-between">

                      <Text fw={600}>
                        {room.title}
                      </Text>

                      <Badge color="blue">
                        {room.price} €
                      </Badge>

                    </Group>

                    <Text size="xs" c="dimmed">
                      {room.maxPeople} personnes
                    </Text>

                  </Card>

                </Grid.Col>

              ))}

            </Grid>

          </Grid.Col>

          <Grid.Col span={12}>

            <DatePickerInput
              type="range"
              label="Dates du séjour"
              value={dates}
              onChange={setDates}
              minDate={new Date()}
            />

          </Grid.Col>

        </Grid>

        {selectedRoom && nights > 0 && (

          <Card withBorder radius="md" p="sm">

            <Group justify="space-between">
              <Text>Nuits</Text>
              <Text fw={600}>{nights}</Text>
            </Group>

            <Divider my="xs" />

            <Group justify="space-between">

              <Text fw={700}>Total</Text>

              {loadingPrice ? (
                <Loader size="sm" />
              ) : (
                <Text fw={700} size="lg">
                  {total ? `${total} €` : "--"}
                </Text>
              )}

            </Group>

          </Card>

        )}

        <Button
          size="md"
          radius="md"
          disabled={!selectedRoom || !dates[0] || !dates[1] || !total}
          onClick={handleSubmit}
        >
          Confirmer la réservation
        </Button>

      </Stack>

    </Card>
  );
}